import type { DealOaApi } from '@openx/types/deal.ts';

export const isDealDeleted = (deal: DealOaApi): boolean => {
  return deal.deleted !== 0;
};
